import React from "react";
import StackGrid from "react-stack-grid";
import { Image } from "../../../Models/Image";
import "../../../Styles/ImageGallery.scss";
import ImageGalleryItem from "./ImageGalleryItem";

const uuid = require("uuid");

type Props = {
  images: Image[];
};

class ImageGallery extends React.Component<Props> {
  render() {
    return (
      <div>
        <h4>Images</h4>
        <div className="gallery-container">
          <StackGrid columnWidth={180} duration={0}>
            {this.props.images.map((item, index) => (
              <ImageGalleryItem image={item} key={uuid()} />
            ))}
          </StackGrid>
        </div>
      </div>
    );
  }
}

export default ImageGallery;
